{
  "name": "17-Ormavi",
  "description": "17-tone 3-Limit Rational Intonation gamut, proposed by Safiaddin Ormavi (1216-1294), generated from 12 perfect fifths descending and 4 ascending plus the fundamental, producing 17 notes per octave derived from harmonic partial row intervals up to a prime limit of 3 (Pythagorean tuning). Thanks to Idin Samimi Mofakham for translation, analysis, and documentation.",
  "scale": [
    "256/243",
    "65536/59049",
    "9/8",
    "32/27",
    "8192/6561",
    "81/64",
    "4/3",
    "1024/729",
    "262144/177147",
    "3/2",
    "128/81",
    "32768/19683",
    "27/16",
    "16/9",
    "4096/2187",
    "1048576/531441",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "17-JI-3L_Ormavi",
  "built_in_group": "Arabic and Persian Theoretical Systems",
  "key_labels": "note_names",
  "note_names": [
    "C",
    "D",
    "D",
    "D",
    "E",
    "E",
    "E",
    "F",
    "F G",
    "G",
    "G",
    "A",
    "A",
    "A",
    "B",
    "B",
    "C"
  ],
  "note_colors": [
    "#ffcbcb",
    "#d0d0d7",
    "#fffae5",
    "#ffffff",
    "#d0d0d7",
    "#fffae5",
    "#ffffff",
    "#ffffff",
    "#d0d0d7",
    "#fffae5",
    "#ffffff",
    "#d0d0d7",
    "#fffae5",
    "#ffffff",
    "#d0d0d7",
    "#fffae5",
    "#fffae5"
  ],
  "equivSteps": 17,
  "fundamental": 440,
  "reference_degree": 13,
  "center_degree": 0,
  "rSteps": 3,
  "drSteps": 1,
  "hexSize": 42,
  "rotation": -16.102113751
}
